import React from 'react'
import './Novostroy.sass'
import Top from '../../components/Top/Top'
import Nav from '../../components/Nav/Nav'
import Header from '../../components/Header/Header'
import Button from '../../ui/Button/Button'
import Footer from '../../components/Footer/Footer'
import FeedsCarousel from '../../components/FeedsCarousel/FeedsCarousel'
import RequestConsultation from '../../components/RequestConsultation/RequestConsultation'
import VikupBenefits from '../Vikup/components/VikupBenefits/VikupBenefits'
import NovostroyBenefits from './NovostroyBenefits/NovostroyBenefits'
import bg from './novostroyHeader.svg'
import Counters from './Counters/Counters'
import Partners from '../../components/Partners/Partners'
import SeoText from '../Home/components/SeoText/SeoText'
import ava from './ava.jpg'
import EstateCarousel from '../../components/EstateCarousel/EstateCarousel'
import NovostroyTile from './NovostroyTile/NovostroyTile'
import k1 from './assets/k1.jpg'
import k2 from './assets/k2.png'
import k3 from './assets/k3.jpg'
import k4 from './assets/k4.jpg'
import NovostroyCalc from './NovostroyCalc/NovostroyCalc'
import Icon from '../../ui/Icon/Icon'

function Novostory() {
  const kompleksy = [
    {
      avatar: k1,
      title: 'ЖК "Бунин"',
      counter: '81',
      address: 'Воронеж, Центральный, ул. Шишкова',
      price: [
        { label: 'Студия', value: 4.27 },
        { label: '1-комн.', value: 5.39 },
        { label: '2-комн.', value: 6.17 },
        { label: '3-комн.', value: 7.2 },
      ],
      startFrom: '4 270 000',
    },
    {
      avatar: k2,
      title: 'ЖК "Алые паруса"',
      counter: '86',
      address: 'Воронеж, ул. МОПРа',
      price: [
        { label: 'Студия', value: 4.1 },
        { label: '1-комн.', value: 4.3 },
        { label: '2-комн.', value: 6.7 },
        { label: '3-комн.', value: 7.9 },
      ],
      startFrom: '4 100 000',
    },
    {
      avatar: k3,
      title: 'ЖК "Инстеп.Краснознаменная"',
      counter: '127',
      address: 'Воронеж, Ленинский, ул. Краснознаменная',
      price: [
        { label: 'Студия', value: 4.4 },
        { label: '1-комн.', value: 5.46 },
        { label: '2-комн.', value: 6.77 },
        { label: '3-комн.', value: 7.9 },
      ],
      startFrom: '4 400 000',
    },
    {
      avatar: k4,
      title: 'ЖК "Молодежный"',
      counter: '190',
      address: 'Воронеж, Советский, ул. Теплоэнергетиков',
      price: [
        { label: '1-комн.', value: 1.8 },
        { label: '2-комн.', value: 4.08 },
      ],
      startFrom: '1 880 000',
    },
  ]
  return (
    <div className="Novostroy">
      <Top />
      <Nav />
      <div className="Page-SectionsContainer">
        <Header
          className={'Novostroy-Header'}
          backgroundSrc={bg}
          title={
            <h1 className="Novostroy-Offer-Title">
              Все новостройки в Воронеже
            </h1>
          }
          description={
            <>
              <h3 className="Novostroy-Offer-Description">
                Получите подборку актуальных предложений от застройщиков
                бесплатно!
              </h3>
              <div className="Ticks">
                <p>
                  <Icon name="check" weight="solid" /> Все расходы по оформлению
                  берем на себя
                </p>
                <p>
                  <Icon name="check" weight="solid" /> Организуем трансфер и
                  показ объектов недвижимости
                </p>
                <p>
                  <Icon name="check" weight="solid" /> Выкупим Вашу недвижимость
                  в качестве обмена на новую
                </p>
              </div>
            </>
          }
          buttons={
            <>
              <Button
                theme="primary"
                title="Получить подборку квартир"
                type="navhashlink"
                path="#calc"
              />
            </>
          }
        />
        <Counters />
        <NovostroyCalc />
        <EstateCarousel
          title="Новые житловые комплексы в Воронеже"
          tiles={
            <>
              {kompleksy.map((k) => (
                <NovostroyTile {...k} />
              ))}
            </>
          }
        />
        <Partners />
        <SeoText
          title="Как купить квартиру от застройщика выгодно и безопасно?"
          img={ava}
          text={`Квартира — крупная покупка со множеством нюансов, решения должны быть приняты рационально. Выбор надежного застройщика один из ключевых моментов покупки. Разберем этот пункт подробнее. Покупка квартиры в строящемся доме имеет свои риски, основные из них — задержка сроков сдачи жилья в эксплуатацию и незавершённое строительство. Внимательно изучите информацию о застройщиках, так вы минимизируете риск. Используйте портал наш.дом.рф и проверьте на нём легальность новостроек и репутацию строительных компаний на рынке недвижимости. На сайте собрана актуальная информация о жилищном строительстве, достоверность которой обеспечивается Федеральным законом от 30.12.2004 N 214-ФЗ «Об участии в долевом строительстве многоквартирных домов и иных объектов недвижимости и о внесении изменений в некоторые законодательные акты Российской Федерации». Дополнительно защищают покупателя эскроу-счета — банковские счета, позволяющие обезопасить расчёт между застройщиком и покупателем. Банк блокирует средства на специальном счёте, и строительная компания получает доступ к деньгам за квартиру только после того, как дом введут в эксплуатацию. Если застройщик не выполнит свои обязательства, покупатель сможет вернуть свои средства.`}
        />
        <NovostroyBenefits />
        <RequestConsultation />
        <FeedsCarousel className="HomeFeeds" />
        <Footer />
      </div>
    </div>
  )
}

export default Novostory
